import { Component, OnInit, OnDestroy } from '@angular/core';
import { AbstractControl, FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ThemePalette } from '@angular/material/core';
import { MatTableDataSource } from '@angular/material/table';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { Subject, Subscription } from 'rxjs';
import { PathwayMapping } from 'src/shared/models/pathway-mapping.model';
import { AuthService } from 'src/shared/services/auth.service';
import { ExtracurricularService } from 'src/shared/services/extracurricular.service';
import { PathwayMappingService } from 'src/shared/services/pathway-mapping.service';
import { ResponseService } from 'src/shared/services/response-service.service';
import { SchoolProgramService } from 'src/shared/services/school-program.service';
import { SetupService } from 'src/shared/services/setup.service';
import { TranslateService } from 'src/shared/services/translate.service';
import { PeriodService } from 'src/shared/services/period.service';
import Swal from 'sweetalert2';


@Component({
  selector: 'app-activity-edit',
  templateUrl: './activity-edit.component.html',
  styleUrl: './activity-edit.component.scss'
})
export class ActivityEditComponent implements OnInit, OnDestroy {

  activityId: number;
  detail: any;
  schoolProgramDetail: any;
  periodSetupSettingDetail: any;
  schoolActivityForm: FormGroup;
  disabledEditParticipant = true;

  test = false;

    heading = "Activity";
    loading = {
      list: false,
      student: false,
      unRegis: false,
      detail: false,
      approver: false
    }
    color: ThemePalette = 'primary';
    usingActivityRule = false;
  
    currentPage = 1;
    schoolActivities: MatTableDataSource<any>;
    total = 0;
    currentAcademic = null;
    hasData = false;
    columnsToDisplay = ['activity_name','activity_description', 'participants', 'action'];
    checkApiRun: Subscription;
    yearLevelList: any[] = [];
  
    disableButtonEdit = true;
    usingScoreRange = false;
    allScorePeriod = true;
    sessionIsOverriden = false;
  
    schoolDay = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'];
    statusList = ['Inactive', 'Active', 'Hold'];
    selectedSchoolDay: string[] = [];
    session: number;

    activityDateInvalid = false;
    activityMaxRegistrationDateInvalid = false;
  
    // score & predicate
    scores: {
      score_name: string,
      activity_score_range_id?: number,
      score_detail: {
        activity_score_detail_id?: number,
        minimum_score?: any,
        maximum_score?: any,
        predicate: string,
        description: string
      }[]
    }[] = [];
  
    totalFee = 0;
  
    approverList = [];
    supervisor = false;
    supervisorList = [];
    coach = false;
    coachList = [];
    searchSupervisor: string;
    searchCoach: string;
  
    sort = 'asc';
    orderBy = 'activity_name'
    yearLevelIds: any = null;
  
    periodList: any[] = [];
    checkedParticipantPeriod: any[] = [];
    scoreRangeByPeriod: { [key: string]: FormArray } = {};
    registeredStudentsByPeriod: { [key: number]: any[] } = {};
    removedStudentsByPeriod: { [key: number]: number[] } = {};
    loadingRegisteredByPeriod: { [key: number]: boolean } = {};
    participantExists = false;
    selectedYearLevelIds: number[] | null = null;
    selectedCopyPeriodIds: number[] = [];
    copyingRegisteredReport = false;

    private destroy$ = new Subject<void>();

  constructor(
    private schoolProgramService: SchoolProgramService,
    private exculService: ExtracurricularService,
    private toastr: ToastrService,
    private modalService: NgbModal,
    private formBuilder: FormBuilder,
    private router: Router,
    private route: ActivatedRoute,
    private translate: TranslateService,
    private rpSer: ResponseService,
    public auth: AuthService,
    private pmService: PathwayMappingService,
    private setupService: SetupService,
    private periodService: PeriodService
  ) {
    this.activityId = this.route.snapshot.params['id'];
  }

  ngOnInit(): void {
    this.auth.loadPermissions(true);
    this.translate.load('activity', 'extracurricular', 'scoring');
    if (this.activityId) {
      this.initForm();
      this.trackFormChanges();
    }
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  click() {
    console.log(this.schoolActivityForm.value);
    console.log(this.detail);
  }

  initForm() {
    this.schoolActivityForm = this.formBuilder.group({
      'school_program_activity_id': new FormControl(null),
      'academic_year': new FormControl(null),
      'school_location_id': new FormControl(null),
      'school_level_id': new FormControl(null),
      'school_program_id': new FormControl(null),
      'school_program_category_id': new FormControl(null),
      'activity_name': new FormControl(null),
      'activity_description': new FormControl(null),
      'year_level_id':new FormControl(null),
      'activity_schedule': this.formBuilder.array([]),
      'start_date': new FormControl(null),
      'end_date': new FormControl(null),
      'sessions': new FormControl(0),
      'session_override': new FormControl(null),
      'using_session_override': new FormControl(null),
      'max_registration_date': new FormControl(null),
      'min_participant': new FormControl(null),
      'max_participant': new FormControl(null),
      'participation_fee': new FormControl('0'),
      'user_id_approver': new FormControl(null),
      'supervisor': new FormControl([]),
      'coach': new FormControl([]),
      'status': new FormControl(null),
      'score_range': this.formBuilder.array([]),
      'using_score_range': new FormControl(false),
      'coach_fee': new FormControl(null), 
      'equipment_fee': new FormControl(null),
      'venue_fee': new FormControl(null),
      'other_fee': new FormControl(null),
      'name_on_report_card': new FormControl(null),
      'gender': new FormControl('all'),
      // 'rule_per_year_level': this.formBuilder.array([]),
      // 'using_rule_per_year_level': new FormControl(null),
    });
    this.getActivityDetail();
  }

  mapFormValue() {
    this.schoolActivityForm.patchValue({
      'school_program_activity_id': this.activityId,
      'academic_year': this.detail.activity.academic_year,
      'school_location_id': this.schoolProgramDetail.school_location_id,
      'school_level_id': this.schoolProgramDetail.school_level_id,
      'school_program_id': this.schoolProgramDetail.school_program_id,
      'school_program_category_id': this.schoolProgramDetail.categories[0].school_program_category_id,
      'activity_name': this.detail.activity.activity_name,
      'activity_description': this.detail.activity.activity_description,
      'start_date': this.detail.activity.start_date,
      'end_date': this.detail.activity.end_date,
      'sessions': this.detail.activity.session,
      'session_override': this.detail.activity.session_override,
      'using_session_override': this.detail.activity.session_override ? true : false,
      'max_registration_date': this.detail.activity.max_registration_date,
      'min_participant': this.detail.activity.min_participant,
      'max_participant': this.detail.activity.max_participant,
      'participation_fee': this.detail.activity.participation_fee === '' ? 0 : this.detail.activity.participation_fee,
      'user_id_approver': this.detail.approver ? this.detail.approver[0].user_id : null,
      'supervisor': this.detail.supervisor ? this.detail.supervisor.map((supervisor: any) => {
        return supervisor.staff_id;
      }) : null,
      'coach': this.detail.coach ? this.detail.coach.map((coach: any) => {
        return coach.user_id;
      }) : null,
      'status': this.detail.activity.status,
      'name_on_report_card': this.detail.activity.name_on_report_card ? this.detail.activity.name_on_report_card : null,
      'gender': this.detail.activity.gender ?? 'all',
    });

    if (this.detail.supervisor && this.detail.supervisor.length > 0) {
      this.supervisor = true;
    }

    if (this.detail.coach && this.detail.coach.length > 0) {
      this.coach = true;
    }

    // if (this.detail.activity_rule && this.detail.activity_rule.length > 0) {
    //   this.patchActivityRules(this.detail.activity_rule);
    // }

    // score
    if (this.detail.score && this.detail.score.length > 0) {
      const hasPeriodSpecificScore = this.detail.score.some((score: any) => this.getScorePeriodId(score) !== null && this.getScorePeriodId(score) !== undefined);
      if (!hasPeriodSpecificScore) {
        this.patchScoreRange(this.detail.score);
      }
    }

    // schedule
    if (this.detail.schedule && this.detail.schedule.length > 0) {
      this.patchSchedule(this.detail.schedule);
    }

    // fee
    if (this.detail.activity.activity_fee) {
      this.patchActivityFee(this.detail.activity.activity_fee);
    }

    // if (this.detail.activity_rule.length > 0) {
    //   this.schoolActivityForm.controls['using_rule_per_year_level'].setValue(true);
    //   this.usingActivityRule = true;
    //   this.patchActivityRules(this.detail.activity_rule);
    // } else {
    //   this.detail.activity.year_level.forEach((yl: any) => {
    //     this.addRulePerYearLevel(yl.year_level_id, yl.description);
    //   });
    // }

    this.test = true;

    this.sessionIsOverriden = this.detail.activity.session_override ? true : false;
  }

  setGender(gender: 'all' | 'M' | 'F'): void {
    this.schoolActivityForm.get('gender')?.setValue(gender);
  }

  get scoreRange(): FormArray {
    return this.schoolActivityForm.get('score_range') as FormArray;
  }

  // get activityFees(): FormGroup {
  //   return this.schoolActivityForm.get('activity_fee') as FormGroup;
  // }

  getScoreRangeDetail(index: number): FormArray {
    return this.scoreRange.at(index).get('score_detail') as FormArray;
  }

  getScoreRange(periodId: any = null): FormArray {
    if (periodId === null || periodId === undefined) {
      return this.scoreRange;
    }
    this.ensureScoreRangeForPeriod(periodId);
    return this.scoreRangeByPeriod[periodId];
  }

  getScoreRangeDetailByPeriod(index: number, periodId: any = null): FormArray {
    return this.getScoreRange(periodId).at(index).get('score_detail') as FormArray;
  }

  get ruleParticipantPerYearLevel(): FormArray {
    return this.schoolActivityForm.get('rule_per_year_level') as FormArray;
  }

  getScorePeriodId(score: any) {
    return score.period_id ?? score.period?.period_id ?? null;
  }

  get isScoreRangeMultiple(): boolean {
    if (this.allScorePeriod) {
      return this.scoreRange.controls.some(score => (score.get('score_detail') as FormArray).length > 1);
    } else {
      return this.periodList.some(period => {
        const scoreRange = this.getScoreRange(period.period_id);
        return scoreRange.controls.some(score => (score.get('score_detail') as FormArray).length > 1);
      });
    }
  }

  

  patchScoreRange(data: any[], periodId: any = null) {
    const scoreRange = this.getScoreRange(periodId);
    scoreRange.clear();
  
    data.forEach(score => {
      const scoreGroup = this.formBuilder.group({
        score_name: score.score_name,
        activity_score_range_id: score.activity_score_range_id ? score.activity_score_range_id : null,
        deleted: false,
        score_detail: this.formBuilder.array([])
      });
  
      scoreRange.push(scoreGroup);
  
      if (score.score_detail && score.score_detail.length > 0) {
        score.score_detail.forEach((detail: any) => {
          const detailGroup = this.formBuilder.group({
            predicate: detail.predicate,
            description: detail.description,
            minimum_score: detail.min_score,
            maximum_score: detail.max_score,
            activity_score_detail_id: detail.activity_score_detail_id ? detail.activity_score_detail_id : null,
            deleted: false
          });
          this.getScoreRangeDetailByPeriod(scoreRange.length - 1, periodId).push(detailGroup);
        });

        // is every score detail has min_score and max_score
        this.usingScoreRange = score.score_detail.every(i => i.min_score !== null  && i.max_score !== null && !isNaN(i.min_score) && !isNaN(i.max_score));
        this.schoolActivityForm.controls['using_score_range'].setValue(this.usingScoreRange);
        this.updateScoreRangeValidator();
      }
    });
  }

  patchScoreRangeByPeriod(data: any[]) {
    const periodScores = data.filter(score => this.getScorePeriodId(score) !== null && this.getScorePeriodId(score) !== undefined);

    if (periodScores.length === 0) {
      this.allScorePeriod = true;
      this.patchScoreRange(data);
      return;
    }

    this.allScorePeriod = false;
    this.periodList.forEach((period: any) => {
      const scores = periodScores.filter(score => +this.getScorePeriodId(score) === +period.period_id);
      this.patchScoreRange(scores.length > 0 ? scores : [], period.period_id);
      if (this.getScoreRange(period.period_id).length === 0) {
        this.addScore(period.period_id);
      }
    });
  }

  addRulePerYearLevel(yearLevelId: number, desc: string) {
    const group = this.formBuilder.group({
      activity_rule_id: null,
      year_level_id: new FormControl(yearLevelId),
      description: new FormControl(desc),
      max_participant: new FormControl(null, Validators.required),
      min_participant: new FormControl(null, Validators.required),
    });
    this.ruleParticipantPerYearLevel.push(group);
  }

  patchSchedule(data: any[]) {
    this.activitySchedule.clear();

    data.forEach(schedule => {
      const scheduleGroup = this.formBuilder.group({
        activity_schedule_id: schedule.activity_schedule_id,
        day: schedule.schoolday,
        time_start: schedule.start_time,
        time_end: schedule.end_time,
        venue: schedule.venue,
        equipment: schedule.equipment,
        check: true
      });

      this.activitySchedule.push(scheduleGroup);
    });

    this.selectedSchoolDay = data.map((schedule: { schoolday: any; }) => schedule.schoolday);
    this.schoolDay.forEach(day => {
      if (!this.selectedSchoolDay.includes(day)) {
        this.addSchedule(day);
      }
    });
  }

  patchActivityRules(data: any[]) {
    this.ruleParticipantPerYearLevel.clear();

    data.forEach(rule => {
      const group = this.formBuilder.group({
        activity_rule_id: rule.activity_rule_id,
        description: rule.yearLevels[0].description,
        max_participant: rule.max_participant,
        min_participant: rule.min_participant,
        year_level_id: rule.yearLevels[0].year_level_id,
        school_program_activity_id: rule.school_program_activity_id,
      });

      this.ruleParticipantPerYearLevel.push(group);
    });
  }

  patchActivityFee(data: any) {
    this.schoolActivityForm.patchValue({
      'coach_fee': data[0].coach_fee === '' ? 0 : data[0].coach_fee,
      'equipment_fee': data[0].equipment_fee === '' ? 0 : data[0].equipment_fee,
      'venue_fee': data[0].venue_fee === '' ? 0 : data[0].venue_fee,
      'other_fee': data[0].other_fee === '' ? 0 : data[0].other_fee
    });
  }

  getActivityDetail() {
    this.schoolProgramService.getSchoolProgramActivityDetail(this.activityId).subscribe({
      next: (response: any) => {
        if (response.status) {
          this.detail = response.data;
          this.yearLevelList = this.detail.year_level_list;
          this.updateSelectedYearLevelIds();
          if (!this.detail.schedule) {
            this.schoolDay.forEach(day => {
              this.addSchedule(day);
            });
          }
          this.getSchoolProgramDetail();
          this.getPeriodSetupSettingNow();
          this.getPeriodList();
        } else {
          this.rpSer.showEditFailed(response.message ? response.message : 'Failed to load activity detail');
        }
      },
      error: (error: any) => {
        this.rpSer.showEditFailed();
      }
    });
  }

  getPeriodSetupSettingNow() {
    const params = {
      year_level_id: this.detail.activity.year_level.map((i: { year_level_id: any; }) => i.year_level_id),
      school_location_id: this.detail.activity.school_location_id,
      academic_year: this.detail.activity.academic_year,
    }
    this.setupService.getPeriodSetupSetting(params).subscribe({
      next: (response: any) => {
        if (response.status) {
          this.periodSetupSettingDetail = response.data;
          // take the oldest "start_date" and the newest "end_date" from the period setup setting
          // prevent admin from modifying data and student manual registration conflicts
          if (this.periodSetupSettingDetail.length > 0) {
            // this.periodId = this.periodSetupSettingDetail[0].period_setup_id;
            const startDate = new Date(Math.min(...this.periodSetupSettingDetail.map((item: { start_date: string; }) => new Date(item.start_date).getTime())));
            const endDate = new Date(Math.max(...this.periodSetupSettingDetail.map((item: { end_date: string; }) => new Date(item.end_date).getTime())));
            if (new Date() <= endDate && new Date() >= startDate) {
              this.disabledEditParticipant = true;
            } else {
              this.disabledEditParticipant = false;
            }
          } else {
            this.disabledEditParticipant = false;
          }
        } else {
          this.rpSer.showEditFailed(response.message ? response.message : 'Failed to load period setup setting');
        }
      },
      error: (error: any) => {
        this.rpSer.showEditFailed();
      }
    });
  }

  getSchoolProgramDetail() {
    this.schoolProgramService.getSchoolProgramDetailFromActivity(this.activityId).subscribe({
      next: (response: any) => {
        if (response.status) {
          this.schoolProgramDetail = response.data;
          this.mapFormValue();
          this.getSupervisor();
          this.getCoach();
          // this.getActivityParticipantApprover();
          this.onChangeFees();
        } else {
          this.rpSer.showEditFailed(response.message ? response.message: 'Something Went Wrong');
        }
      },
      error: (error: any) => {
        this.rpSer.showEditFailed();
      }
    });
  }

  getPeriodList() {
    this.periodService.getPeriods().subscribe((response: any) => {
      this.periodList = response.result.data;
      this.checkedParticipantPeriod = this.periodList.map((period: any) => ({
        period_id: period.period_id,
        participants: [],
        all: false
      }));
      this.periodList.forEach((period: any) => {
        this.ensureScoreRangeForPeriod(period.period_id);
        this.getRegisteredStudentsForPeriod(period.period_id);
        this.removedStudentsByPeriod[period.period_id] = [];
      });
      if (this.detail?.score && this.detail.score.length > 0) {
        this.patchScoreRangeByPeriod(this.detail.score);
      }
    });
  }

  getRegisteredStudentsForPeriod(periodId: number) {
    this.loadingRegisteredByPeriod[periodId] = true;
    this.schoolProgramService.getActivityParticipantList({
      school_program_activity_id: this.activityId,
      period_id: periodId
    }).subscribe({
      next: (response: any) => {
        if (response.status) {
          this.registeredStudentsByPeriod[periodId] = response.data ? response.data.slice() : [];
        } else {
          this.registeredStudentsByPeriod[periodId] = [];
        }
        this.updateParticipantExists();
        this.loadingRegisteredByPeriod[periodId] = false;
      },
      error: () => {
        this.registeredStudentsByPeriod[periodId] = [];
        this.updateParticipantExists();
        this.loadingRegisteredByPeriod[periodId] = false;
      }
    });
  }

  updateParticipantExists() {
    this.participantExists = Object.values(this.registeredStudentsByPeriod)
      .some(students => Array.isArray(students) && students.length > 0);
  }

  openCopyToOtherPeriodModal(content: any): void {
    this.selectedCopyPeriodIds = [];
    this.modalService.open(content, {
      ariaLabelledBy: 'copy-to-other-period-title',
      centered: true
    });
  }

  toggleCopyPeriod(periodId: number, checked: boolean): void {
    if (checked) {
      this.selectedCopyPeriodIds = [...this.selectedCopyPeriodIds, periodId];
      return;
    }

    this.selectedCopyPeriodIds = this.selectedCopyPeriodIds.filter(id => +id !== +periodId);
  }

  isCopyPeriodSelected(periodId: number): boolean {
    return this.selectedCopyPeriodIds.some(id => +id === +periodId);
  }

  copyRegisteredReport(modal: any): void {
    const sourcePeriod = this.periodList[0];
    if (!sourcePeriod || this.selectedCopyPeriodIds.length === 0) {
      return;
    }

    this.copyingRegisteredReport = true;
    this.schoolProgramService.copyRegisteredReport({
      school_program_activity_id: this.activityId,
      source_period_id: sourcePeriod.period_id,
      periods: this.selectedCopyPeriodIds.map(periodId => ({ period_id: periodId }))
    }).subscribe({
      next: (response: any) => {
        this.copyingRegisteredReport = false;
        if (response.status) {
          modal.close();
          this.rpSer.showEditSuccess(response.message || 'Registered students have been copied successfully.');
          this.selectedCopyPeriodIds.forEach(periodId => this.getRegisteredStudentsForPeriod(periodId));
        } else {
          modal.close();
          this.rpSer.showWarning(response.message || 'Failed to copy registered students.');
        }
      },
      error: () => {
        this.copyingRegisteredReport = false;
        this.rpSer.showEditFailed('Failed to copy registered students.');
      }
    });
  }

  onCheckedParticipantsChange(payload: any, period: any): void {
    if (payload === 'all') {
      this.checkedParticipantPeriod = this.checkedParticipantPeriod.map(p => {
        if (+p.period_id === +period.period_id) {
          return { ...p, participants: [], all: true };
        }
        return p;
      });
    } else {
      this.checkedParticipantPeriod = this.checkedParticipantPeriod.map(p => {
        if (+p.period_id === +period.period_id) {
          return { ...p, participants: payload.participants || [], all: false };
        }
        return p;
      });
    }
  }

  onRemoveParticipant(studentId: number, periodId: number) {
    if (!this.removedStudentsByPeriod[periodId]) {
      this.removedStudentsByPeriod[periodId] = [];
    }
    if (this.removedStudentsByPeriod[periodId].includes(studentId)) {
      this.removedStudentsByPeriod[periodId].splice(this.removedStudentsByPeriod[periodId].indexOf(studentId), 1);
    } else {
      this.removedStudentsByPeriod[periodId].push(studentId);
    }
  }

  isRemovedParticipant(studentId: number, periodId: number): boolean {
    if (!this.removedStudentsByPeriod[periodId]) return false;
    return this.removedStudentsByPeriod[periodId].includes(studentId);
  }

  updateSelectedYearLevelIds() {
    const ids = this.yearLevelList
      .filter((yl: any) => yl.checked)
      .map((yl: any) => yl.year_level_id);
    this.selectedYearLevelIds = ids.length > 0 ? [...ids] : null;
  }

  onChangeYearLevelByCheckbox(event: any, item: any) {
    item.checked = event.checked;
    this.updateSelectedYearLevelIds();
  }

  onChangeApprover(item: any) {
    this.schoolActivityForm.controls['user_id_approver'].markAsTouched();
    this.schoolActivityForm.controls['user_id_approver'].setValue(item ? item.user_id : null);
  }

  onChangeCoach(item: any) {
    this.schoolActivityForm.controls['coach'].markAsTouched();
    const data = item.map((i: { user_id: any; }) => i.user_id);
    this.schoolActivityForm.controls['coach'].setValue(data.length > 0 ? data : null);
  }

  onChangeSupervisor(item: any) {
    this.schoolActivityForm.controls['supervisor'].markAsTouched();
    const data = item.map((i: { staff_id: any; }) => i.staff_id);
    this.schoolActivityForm.controls['supervisor'].setValue(data.length > 0 ? data : null);
  }

  onChangeStatus(item: any) {
    this.schoolActivityForm.controls['status'].markAsTouched();
    this.schoolActivityForm.controls['status'].setValue(item ? item : null);
  }
  
  onCancel() {
    this.modalService.dismissAll();
  }

  get activitySchedule(): FormArray {
    return this.schoolActivityForm.get('activity_schedule') as FormArray;
  }

  onChangeSchoolDay(selectedDays: string[]) {
    if (selectedDays.length === 0) {
      this.activitySchedule.clear();
      this.selectedSchoolDay = [];
    }
    selectedDays.forEach(day => {
      if (!this.selectedSchoolDay.includes(day)) {
        this.addSchedule(day);
        this.selectedSchoolDay.push(day);
      }
    });
    if (this.selectedSchoolDay.length !== selectedDays.length) {
      this.selectedSchoolDay.forEach((schoolday, index) => {
        if (!selectedDays.includes(schoolday)) {
          this.activitySchedule.removeAt(index);
        }
      });
    }
    this.sessionCount();
  }

  sessionCount() {
    const start = this.schoolActivityForm.controls['start_date'].value;
    const end = this.schoolActivityForm.controls['end_date'].value;
    if (start && end) {
      let sessionCounter = 0;
      for (var d = new Date(start); d <= new Date(end); d.setDate(d.getDate() + 1)) {
        for (let i = 0; i < this.selectedSchoolDay.length; i++) {
          if (d.toString().split(' ')[0] === this.selectedSchoolDay[i].substring(0,3)) {
            sessionCounter++;
          }
        }
      }
      this.schoolActivityForm.patchValue({sessions: sessionCounter});
    } else {
      this.schoolActivityForm.patchValue({sessions: 0});
    }
  }

  onToogleSessionOverride() {
    this.sessionIsOverriden = !this.sessionIsOverriden;
    this.schoolActivityForm.controls['using_session_override'].setValue(this.sessionIsOverriden ? true : false);
  }

  onBack() {
    this.router.navigate(['../../'], {relativeTo: this.route});
  }

  // getActivityParticipantApprover() {
  //     this.loading.approver = true;
  
  //     this.schoolProgramService.getActivityParticipantApprover(this.schoolActivityForm.get('school_location_id')?.value, {year_level_id : this.detail.activity.year_level.map((i: { year_level_id: any; }) => i.year_level_id), academic_year: this.detail.activity.academic_year})
  //       .subscribe((response: any) => {
  //         if (response.status) {
  //           this.approverList = response.data;
  //         } else {
  //           this.rpSer.showEditFailed(response.message ? response.message : 'Failed to add the school program activity. Please try again.');
  //         }
  //         this.loading.approver = false;
  //       }, error => {
  //         this.rpSer.showEditFailed();
  //         this.loading.approver = false;
  //       });
  //   }

  switchSupervisor() {
    this.supervisor = !this.supervisor;
  }

  switchCoach() {
    this.coach = !this.coach;
  }

  onChangeFeesParticipationFee() {
    if (this.schoolActivityForm.controls['participation_fee'].value === '') {
      this.schoolActivityForm.controls['participation_fee'].setValue(0);
    }
  }

  onChangeFees() {
    if (this.schoolActivityForm.controls['equipment_fee'].value === '') {
      this.schoolActivityForm.controls['equipment_fee'].setValue(0);
    }
    if (this.schoolActivityForm.controls['venue_fee'].value === '') {
      this.schoolActivityForm.controls['venue_fee'].setValue(0);
    }
    if (this.schoolActivityForm.controls['other_fee'].value === '') {
      this.schoolActivityForm.controls['other_fee'].setValue(0);
    }
    if (this.schoolActivityForm.controls['coach_fee'].value === '') {
      this.schoolActivityForm.controls['coach_fee'].setValue(0);
    }
    this.totalFee = 
    this.schoolActivityForm.controls['equipment_fee'].value +
    this.schoolActivityForm.controls['venue_fee'].value +
    this.schoolActivityForm.controls['other_fee'].value +
    this.schoolActivityForm.controls['coach_fee'].value;
  }

  createScoreGroup() {
    const scoreGroup = this.formBuilder.group({
      score_name: new FormControl(null),
      deleted: false,
      score_detail: this.formBuilder.array([])
    });

    return scoreGroup;
  }

  ensureScoreRangeForPeriod(periodId: any) {
    if (!this.scoreRangeByPeriod[periodId]) {
      this.scoreRangeByPeriod[periodId] = this.formBuilder.array([]);
      this.addScore(periodId);
    }
  }

  addScore(periodId: any = null) {
    const scoreRange = this.getScoreRange(periodId);
    scoreRange.push(this.createScoreGroup());
    this.addScoreDetail(scoreRange.length - 1, periodId);
  }

  getRowspan(index: number, periodId: any = null): number {
    const details = this.getScoreRangeDetailByPeriod(index, periodId);
    return details.length > 0 ? details.length + 1 : 1;
  }

  removeScore(scoreIndex: number, periodId: any = null) {
    // this.scoreRange.removeAt(scoreIndex);
    this.getScoreRange(periodId).at(scoreIndex)?.get('deleted')?.setValue(true);
  }

  addScoreDetail(index: number, periodId: any = null) {
    let detailGroup;
    if (this.usingScoreRange) {
        detailGroup = this.formBuilder.group({
            minimum_score: new FormControl(null, Validators.required),
            maximum_score: new FormControl(null, Validators.required),
            predicate: new FormControl(null),
            description: new FormControl(null),
            deleted: false
        });
    } else { 
        detailGroup = this.formBuilder.group({
            minimum_score: new FormControl(null),
            maximum_score: new FormControl(null),
            predicate: new FormControl(null),
            description: new FormControl(null),
            deleted: false
        });
    }
    this.getScoreRangeDetailByPeriod(index, periodId).push(detailGroup);
  }

  removeScoreDetail(scoreIndex: number, detailIndex: number, periodId: any = null) {
    // this.getScoreRangeDetail(scoreIndex).removeAt(detailIndex);
    this.getScoreRangeDetailByPeriod(scoreIndex, periodId).at(detailIndex)?.get('deleted')?.setValue(true);
  }

  convertToFormControl(absCtrl: AbstractControl | null): FormControl {
    const ctrl = absCtrl as FormControl;
    return ctrl;
  }

  addSchedule(day: string) {
    const scheduleArray = this.schoolActivityForm.get('activity_schedule') as FormArray;
    scheduleArray.push(this.formBuilder.group({
      day: [day],
      check: [false],
      time_start: [''],
      time_end: [''],
      venue: [''],
      equipment: ['']
    }));
  }

  onChangeSchoolDayByCheckbox(event: any, index: number) {
    const scheduleArray = this.schoolActivityForm.get('activity_schedule') as FormArray;
    scheduleArray.at(index).patchValue({ check: event.checked });
    if (event.checked) {
      this.selectedSchoolDay.push(scheduleArray.at(index).value.day);
    } else {
      this.selectedSchoolDay.splice(this.selectedSchoolDay.indexOf(scheduleArray.at(index).value.day), 1);
    }
    this.sessionCount();
  }

  onChangeActivityRuleBox() {
    this.usingActivityRule = !this.usingActivityRule;
    this.schoolActivityForm.controls['using_rule_per_year_level'].setValue(this.usingActivityRule ? true : false);
  }

  onChangeScorePredicate() {
    this.usingScoreRange = !this.usingScoreRange;
    this.schoolActivityForm.controls['using_score_range'].setValue(this.usingScoreRange ? true : false);
    this.updateScoreRangeValidator();
  }

  onToggleAllScorePeriod() {
    this.allScorePeriod = !this.allScorePeriod;
    this.periodList.forEach((period: any) => this.ensureScoreRangeForPeriod(period.period_id));
  }

  updateScoreRangeValidator() {
    const scoreRanges = this.allScorePeriod
      ? [this.scoreRange]
      : this.periodList.map((period: any) => this.getScoreRange(period.period_id));

    scoreRanges.forEach(scoreRange => scoreRange.controls.forEach(i => {
      const details = i.get('score_detail') as FormArray;

      details.controls.forEach(j => {
        if (this.usingScoreRange) {
          j.get('minimum_score').setValidators(Validators.required);
          j.get('maximum_score').setValidators(Validators.required);
        } else {
          j.get('minimum_score').removeValidators(Validators.required);
          j.get('maximum_score').removeValidators(Validators.required);
        }
      })
    }))
  }

  getSupervisor() {
    this.supervisorList = [];
    this.schoolProgramService.getSupervisorList(this.schoolActivityForm.get('school_location_id')?.value).subscribe({
      next: (response: any) => {
        if (response.status) {
          this.supervisorList = response.data;
        } else {
          this.rpSer.showEditFailed(response.message ? response.message : 'Failed to load supervisor list. Please try again.');
        }
      },
      error: (error: any) => {
        this.rpSer.showEditFailed();
      }
    });
  }

  getCoach() {
    this.coachList = [];
    const id = this.schoolActivityForm.get('school_location_id')?.value;
    this.schoolProgramService.getCoachList(id).subscribe({
      next: (response: any) => {
        if (response.status) {
          this.coachList = response.data;
        } else {
          this.rpSer.showEditFailed(response.message ? response.message : 'Failed to load coach list. Please try again.');
        }
      },
      error: (error: any) => {
        this.rpSer.showEditFailed();
      }
    })
  }

  trackFormChanges() {
    this.schoolActivityForm.valueChanges.subscribe(() => {
      let ruleInvalid = false;
      if (this.usingActivityRule) {
        ruleInvalid = this.ruleParticipantPerYearLevel.invalid;
      } else {
        ruleInvalid = this.schoolActivityForm.get('min_participant')?.value === null ||
                      this.schoolActivityForm.get('max_participant')?.value === null;
      }
      this.disableButtonEdit =
          !this.schoolActivityForm.get('activity_name')?.value ||
          !this.schoolActivityForm.get('school_program_category_id')?.value ||
          !this.schoolActivityForm.get('start_date')?.value ||
          !this.schoolActivityForm.get('end_date')?.value ||
          !this.schoolActivityForm.get('max_registration_date')?.value ||
          ruleInvalid ||
          !this.schoolActivityForm.get('status')?.value ||
          (this.sessionIsOverriden && !this.schoolActivityForm.get('session_override')?.value) ||
          this.activityDateInvalid || 
          this.activityMaxRegistrationDateInvalid;
    });
  }

  onSubmitEdit(){
    let ylChanged = false;
    const checkedLength = this.yearLevelList.filter((i: any) => i.checked).length;
    if (+checkedLength !== +this.detail.activity.year_level.length) {
      ylChanged = true;
    } else {
      this.yearLevelList.forEach((i: any) => {
        if (i.checked) {
          if (this.detail.activity.year_level.find((j: any) => +j.year_level_id === +i.year_level_id) === undefined) {
            ylChanged = true;
          }
        } else {
          if (this.detail.activity.year_level.find((j: any) => +j.year_level_id === +i.year_level_id) !== undefined) {
            ylChanged = true;
          }
        }
      });
    }

    const periodParticipants = this.checkedParticipantPeriod.map(p => ({
      period_id: p.period_id,
      participant_ids: p.all ? [] : p.participants.map((s: any) => s.student_id),
      all: p.all
    }));

    const params = {
      school_program_activity_id: this.detail.school_program_activity_id,
      manage_participant_only: false,
      period_participants: periodParticipants,
      studentRemove: this.removedStudentsByPeriod,
      year_level_id: this.yearLevelList.filter((i: any) => i.checked).map((i: { year_level_id: any; }) => i.year_level_id),
      year_level_changed: ylChanged,
      data: {
        ...this.schoolActivityForm.value,
        score_range: this.buildScoreRangePayload()
      },
      bypass_payment: false
    }

    params.data.gender = params.data.gender === 'all' ? null : params.data.gender;

    if (this.participantExists) {
      params.data.participation_fee = this.detail.activity.participation_fee;
    }

    if (params.year_level_id.length === 0) {
      Swal.fire({
        title: 'No Year Level Selected',
        text: 'Please select at least one year level to continue.',
        icon: 'warning',
        confirmButtonText: 'OK',
      });
      return;
    }

    if (this.isScoreRangeInvalid()) {
      Swal.fire({
        title: 'Invalid Score Range',
        text: 'Please complete all required fields in score range.',
        icon: 'warning',
        confirmButtonText: 'OK',
      });
      return;
    }

    if (params.period_participants.length > 0 && (params.period_participants[0].participant_ids.length > 0 || params.period_participants[0].all) && this.schoolActivityForm.get('participation_fee')?.value > 0 && this.auth.permissions['SCHOOL_PROGRAM_ADD_PARTICIPANT_BYPASS_PAYMENT']) {
      Swal.fire({
        title: 'Bypass Payment Confirmation',
        text: 'Do you want to bypass payment for added participants?',
        icon: 'question',
        showCancelButton: true,
        showCloseButton: true,
        confirmButtonText: 'Yes',
        cancelButtonText: 'No',
        allowOutsideClick: false,
      }).then((result) => {
        if (result.dismiss === Swal.DismissReason.close) {
          return;
        }
        params.bypass_payment = result.isConfirmed;
        this.submitEditActivity(params);
      });
    } else {
      this.submitEditActivity(params);
    }
  }

  submitEditActivity(params: any) {
    this.schoolProgramService.updateSchoolProgramActivity(params).subscribe(
        (response: any) => {
          if (response['status']) {
            this.rpSer.showEditSuccess('The school program activity has been edited successfully.');
            this.router.navigate(['../../'], {relativeTo: this.route});
          } else {
            this.rpSer.showEditFailed('Failed to edit the school program activity. Please try again.');
          }
        },
        (error: any) => {
          this.rpSer.showEditFailed();
        }
    );
  }

  buildScoreRangePayload() {
    const periodIds = [
      ...this.periodList.map((period: any) => ({ period_id: period.period_id, deleted: this.allScorePeriod })),
      { period_id: null, deleted: !this.allScorePeriod }
    ]
    return periodIds.flatMap((period: any) => {
      return this.getScoreRange(period.period_id).value.map((score: any) => ({
        ...score,
        period_id: period.period_id,
        deleted: period.deleted,
      }));
    });


  }

  isScoreRangeInvalid(): boolean {
    if (this.allScorePeriod) {
      return this.scoreRange.invalid;
    }

    return this.periodList.some((period: any) => this.getScoreRange(period.period_id).invalid);
  }

  changeActivityDate() {
    this.activityDateInvalid = this.schoolActivityForm.get('start_date')?.value > this.schoolActivityForm.get('end_date')?.value;
    this.activityMaxRegistrationDateInvalid = this.schoolActivityForm.get('max_registration_date')?.value > this.schoolActivityForm.get('end_date')?.value;
    this.sessionCount();
  }

}
